import * as React from 'react'
import { SelectOption } from './SelectOption'
import { SelectOptionsProps } from './types'

export const SelectOptions: React.FC<SelectOptionsProps> = ({
    options,
    selectOptionsClassname,
    optionLabelClassname,
    optionWrapperClassname,
    name,
    disabled,
    onChange,
    variant,
    value,
}) => {
    return (
        <fieldset
            className={selectOptionsClassname}
            role="listbox"
            data-testid={`${name}-select-options`}
            disabled={disabled}
        >
            {options.map((option, index) => {
                const optionValue = JSON.stringify(option.value)
                const selected = option.value === value

                return (
                    <SelectOption
                        key={optionValue}
                        index={index}
                        name={name}
                        value={optionValue}
                        selected={selected}
                        optionWrapperClassname={optionWrapperClassname}
                        disabled={!!option.disabled}
                        optionLabelClassname={optionLabelClassname}
                        onChange={() => {
                            onChange(option.value)
                        }}
                        variant={variant}
                    >
                        {option.label}
                    </SelectOption>
                )
            })}
        </fieldset>
    )
}
